module.exports = __webpack_public_path__ + "img/chatgpt.776e54c4.png";